import * as fs from 'node:fs/promises';
import { gunzipSync } from 'node:zlib';
import { resolveWorkspacePath, WORKSPACE_PATHS } from './paths.js';
import type { RunDataExecutionContext, RunDataSandboxLogs } from './run-data.js';

export const writeExecutionEvidence = async (input: {
  workspaceRoot: string;
  execution?: RunDataExecutionContext;
  sandboxLogs?: RunDataSandboxLogs | null;
  sandboxLogsGzipPath: string | null;
}): Promise<{ partial: boolean; sandboxLogsWritten: boolean }> => {
  if (input.execution) {
    await fs.writeFile(
      resolveWorkspacePath(input.workspaceRoot, WORKSPACE_PATHS.executionContext),
      `${JSON.stringify(input.execution, null, 2)}\n`,
      'utf8'
    );
  }
  if (input.sandboxLogs) {
    await fs.writeFile(
      resolveWorkspacePath(input.workspaceRoot, WORKSPACE_PATHS.logsSandboxMeta),
      `${JSON.stringify(input.sandboxLogs, null, 2)}\n`,
      'utf8'
    );
  }

  if (input.sandboxLogsGzipPath) {
    try {
      const compressed = await fs.readFile(input.sandboxLogsGzipPath);
      const jsonl = gunzipSync(compressed);
      await fs.writeFile(
        resolveWorkspacePath(input.workspaceRoot, WORKSPACE_PATHS.logsSandbox),
        jsonl
      );
    } catch {
      return { partial: true, sandboxLogsWritten: false };
    }
  }

  const expectedArtifact =
    input.sandboxLogs?.status === 'available' || input.sandboxLogs?.status === 'partial';
  return {
    partial:
      input.sandboxLogs?.status === 'partial' ||
      input.sandboxLogs?.status === 'unavailable' ||
      (expectedArtifact && !input.sandboxLogsGzipPath),
    sandboxLogsWritten: Boolean(input.sandboxLogsGzipPath),
  };
};
